(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rr-card-bar"] && !Shopify.designMode) return;
  try {
    window.rrCardBuy = function (btn) {
    var card = btn.closest('product-card');
    var qa = card ? card.querySelector('quick-add-component') : null;
    if (qa) {
      var kind = qa.getAttribute('data-quick-add-button') || 'choose';
      var target = qa.querySelector('.quick-add__button--' + kind) || qa.querySelector('.quick-add__button');
      if (target) {
        target.click();
        return true;
      }
    }
    window.location.href = btn.getAttribute('data-url');
    return true;
  };
  } catch(e) { console.error(e); }
})();

})();
